import React from 'react';
import BlazeLink from '../../BlazeLink';
import buildPaginationUrl from './build-pagination-url';
import { PAGINATION_DISPLAY_LIMIT, PAGINATION_DIFFERENCE } from '../../../constants';

const buildPaginationItems = ({ name, numberOfPages, currentPage, query, url, onClick }) => {
  const pages = [];
  const paginationDifference =
    currentPage > PAGINATION_DIFFERENCE ? currentPage - PAGINATION_DIFFERENCE : 0;

  if (numberOfPages <= 1) return null;

  for (let index = 0; index < numberOfPages; index += 1) {
    const page = index + 1 + paginationDifference;
    if (pages.length < PAGINATION_DISPLAY_LIMIT && page <= numberOfPages) {
      const href = buildPaginationUrl(name, page, query, url);
      const pageHtml =
        page === currentPage ? (
          <span key={page} className="pagination_page-item--current">
            {page}
          </span>
        ) : (
          <BlazeLink
            key={page}
            href={href}
            className="pagination_page-item"
            onClick={onClick}
            shallow
            scroll
            ariaLabel={`Page ${page}`}>
            {page}
          </BlazeLink>
        );
      pages.push(pageHtml);
    }
  }

  return pages;
};

export default buildPaginationItems;
